import computeCreateReducer from '../components/ComputeCreateContainer/ComputeCreateContainer.ducks';
export * from '../components/ComputeCreateContainer/ComputeCreateContainer.ducks';
export default computeCreateReducer;

//# sourceMappingURL=ComputeCreate.ducks.js.map
